module.exports = __webpack_public_path__ + "static/media/background_side_menu.28dbacac.svg";